import React from 'react';
import { NavLink } from 'react-router-dom';
import { Logo } from '@core/index';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { appRoute } from '@utils/globalConstant';
import { NavigationLink } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { useA11y } from '@context/Utils/A11y';

export const NavigationHeader = () => {
  const { tA11yTranslate } = useA11y();

  // Functions
  // Used to determine if the current route is active (active nav link has different style and isn't clickable)
  const isActiveRoute = (route) => location.pathname.startsWith(route);
  const isExactActiveRoute = (route) => location.pathname === route;

  const menuLink1 = tA11yTranslate('ek_reg_nav_lnk1').content;
  const menuLinkLogo = tA11yTranslate('ek_reg_nav_logo').ariaLabel;

  return (
    <div className="bg-ek-glass">
      <AppPageContentWrapper isDefaultPadding={false}>
        <nav className="d-flex align-items-center py-16">
          <div className="d-flex justify-content-between align-items-center flex-grow-1">
            <a
              href="https://www.edeka-smart.de/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={menuLinkLogo}
              className="d-inline-block"
              style={{ marginBottom: '-55px', zIndex: 1 }}>
              <Logo variant="blue" height="77px" />
            </a>

            <NavigationLink
              to={appRoute.ACTIVATION}
              isActiveNavLink={isActiveRoute(appRoute.ACTIVATION)}>
              {menuLink1}
            </NavigationLink>
          </div>
        </nav>
      </AppPageContentWrapper>
    </div>
  );
};

export default NavigationHeader;
